module.exports = __webpack_public_path__ + "media/images/athletes/3445-92875e11db778f51aab6ea998e0ed945.png";